import { CheckBoxGroupItem } from '../../../Components'
import { cap } from '../../../State'
import { translations } from '../../../translations'

const language = cap.language.state || 'IT'
const t = translations[language]

const steps = [t.raccoltaInformazioni, t.creazioneTrasfertaServizi, t.creazionePreventivo]

const StepChooseModeAI = ({ selectedSteps: [selectedSteps, setSelectedSteps], b4bEnabled = 0 }) => {
  const isStep2HiddenByB4B = !b4bEnabled && selectedSteps === '2'

  return (
    <div className="nsec">
      <div className="nsec__head">
        <div className="nsec__ico">
          <i className="pi pi-bolt" style={{ fontSize: 16 }} />
        </div>
        <h3 className="nsec__title">{t.abilitazioneStepAvanzamento}</h3>
      </div>
      <div className="nsec__body">
        <div style={{ display: 'flex', gap: 10 }}>
          <CheckBoxGroupItem
            steps={steps}
            i="0"
            selected={selectedSteps === '0'}
            onClick={() => setSelectedSteps('0')}
          />
          <CheckBoxGroupItem
            steps={steps}
            i="1"
            selected={selectedSteps === '1'}
            onClick={() => setSelectedSteps('1')}
          />
          {(!!b4bEnabled || selectedSteps === '2') && (
            <div className={isStep2HiddenByB4B ? 'community-step-card-warning-wrapper' : ''}>
              <CheckBoxGroupItem
                steps={steps}
                i="2"
                selected={selectedSteps === '2'}
                onClick={() => setSelectedSteps('2')}
                style={
                  isStep2HiddenByB4B
                    ? { borderColor: 'var(--warning)', pointerEvents: 'none', opacity: 0.85 }
                    : undefined
                }
              />
              {isStep2HiddenByB4B && (
                <div className="community-step-warning">
                  <i className="pi pi-exclamation-triangle" />
                  <span>{t.stepNascostoB4B}</span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default StepChooseModeAI
